import { render, staticRenderFns } from "./SubmitWorkersForShifts.vue?vue&type=template&id=91400972&"
import script from "./SubmitWorkersForShifts.vue?vue&type=script&lang=js&"
export * from "./SubmitWorkersForShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports